const separationCharacter = ';'
const eol = '\n'

export class CsvUtils{

    static buildCsv(content){
        let csvString = ""
        for(let i = 0; i < content.length; i++){
            
            csvString += content[i].join(separationCharacter) + eol
        }
        return csvString
    }
}